export const PLUGIN_NAME = "Dynamic Slug Prefix";
export const PLUGIN_ID = "dynamicslugprefix";

// TODO: move to plugin settings?
export const EMPTY_LENGTH = 0;
export const JSON_INDENT_SIZE = 2;
export const FIELD_TOKENS = {
    apiName: "API_NAME",
    globalDomain: "GLOBAL_DOMAIN",
    locale: "LOCALE",
    parent: "PARENT",
};
